import { px2rem } from '../utils/helpers/style.js';

var dateBrowserThemeWeb = {
  color: 'primary',
  colorPressed: 'text.secondary',
  fontSize: px2rem(18),
  sizings: {
    xs: {
      height: px2rem(40)
    },
    s: {
      height: px2rem(48)
    },
    m: {
      height: px2rem(56)
    },
    l: {
      height: px2rem(64)
    }
  },
  trigger: {
    borderRadius: 'borders.radius'
  },
  navigationButtons: {
    backgroundColor: 'background',
    iconColor: 'primary',
    borderRadius: 'borders.radius',
    borderStyle: 'none'
  }
};
var dateBrowserThemeNative = {
  color: 'primary',
  backgroundColor: 'background'
};

export { dateBrowserThemeNative, dateBrowserThemeWeb };
